import { useState } from "react";
import { IconButton, Popover, Typography, Box, Divider } from "@mui/material";
import { Info } from "@mui/icons-material";
import TotalPayments from "./TotalPayments"; // Ensure correct import

const BalanceInfo = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "balance-popover" : undefined;

  const totalAllocatedToBill = data.subList.reduce((total, singleSub) => {
    const bill = singleSub.paid_bills.find((s) => s.miller_account === data.id);
    return bill ? total + Number(bill.allocated_to_bill) : total;
  }, 0);

  const finalAmount = Number(data.miller_final_amount ?? 0);
  const balance = finalAmount - totalAllocatedToBill;

  const rows = [
    {
      label: "Final Amount",
      value: `₹ ${finalAmount.toFixed(2)}/-`,
      //   color: "#2563eb",
    },
    {
      label: "Total Paid",
      value: (
        <Box display="flex" flexDirection="row" alignItems="flex-end">
          <TotalPayments data={data} tableList={data.subList ?? []} />
          <Typography fontSize="0.775rem">
            {`₹ ${totalAllocatedToBill.toFixed(0)}/-`}
          </Typography>
        </Box>
      ),
      color: "#16a34a",
    },
    {
      label: "Remaining Balance",
      value: `₹ ${balance.toFixed(0)}/-`,
      color: balance !== 0 ? "rgb(255, 61, 0)" : "#10b981",
    },
  ];

  return (
    <>
      <Box display="flex" alignItems="center">
        <Typography
          onClick={handleOpen}
          sx={{
            color: balance !== 0 ? "rgb(255, 61, 0)" : "#10b981",
            textDecoration: "underline",
            textUnderlineOffset: "4px",
            cursor: "pointer",
          }}
          fontSize="0.775rem"
        >
          {`₹ ${balance.toFixed(0)}/-`}
        </Typography>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, minWidth: "260px" }}>
          <Typography fontWeight="bold" fontSize="0.85rem" mb={1}>
            Payment Summary
          </Typography>
          {rows.map((item, index) => (
            <Box key={index} mb={index < rows.length - 1 ? 1.5 : 0}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                <Typography fontSize="0.775rem" sx={{ color: "#6b7280" }}>
                  {item.label}
                </Typography>
                <Typography
                  fontSize="0.775rem"
                  textAlign="right"
                  sx={{ color: item.color }}
                >
                  {item.value}
                </Typography>
              </Box>
              {index < rows.length - 1 && <Divider sx={{ my: 1 }} />}
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default BalanceInfo;
